/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-03 11:08:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-26 10:53:33
 * @FilePath: /src/components/Pagination/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Pagination as MuiPagination, PaginationItem, SxProps, Theme } from '@mui/material';

/**
 * @name 自定义分页组件
 *
 * @param {number} total - 总条目数
 * @param {number} current - 当前页码
 * @param {number} pageSize - 每页显示的条目数
 * @param {string} className - 自定义CSS类名
 * @param {Function} onChange - 页码变化时的回调函数
 * @returns {JSX.Element} 分页组件
 */
export default function Pagination({
  total,
  current,
  pageSize,
  className = '',
  onChange,
  sx,
}: {
  total: number;
  current: number;
  pageSize: number;
  className?: string;
  onChange?: (event: React.ChangeEvent<unknown>, value: number) => void;
  sx?: SxProps<Theme>;
}) {
  // 计算总页数
  const pageCount = Math.ceil(total / pageSize);

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <MuiPagination
        count={pageCount}
        page={current}
        onChange={onChange}
        shape="rounded"
        renderItem={(item) => <PaginationItem {...item} />}
        sx={{
          '& .MuiPaginationItem-root': {
            margin: '0 8px',
            width: '38px',
            height: '38px',
            fontSize: '14px',
            borderRadius: '8px',
          },
          '& .MuiPaginationItem-page': {
            backgroundColor: '#f4f4f4',
          },
          '& .Mui-disabled': {
            color: '#282828 !important',
            opacity: 0.2,
            cursor: 'not-allowed',
          },
          // TODO: 暂时不支持ellipsis的点击
          // '& .MuiPaginationItem-ellipsis': {
          //   cursor: 'pointer',
          //   '&:hover': {
          //     backgroundColor: '#463AE81A !important',
          //     color: '#282828 !important',
          //   },
          // },
          ...sx,
        }}
      />
    </div>
  );
}
